import {
  SET_MEMBERSHIP_DATA,
  SET_BANK_DETAILS_FOR_MEMBERSHIP,
  SET_MEMBERSHIP_TEAM_MEMBER,
  SET_BANK_DETAIL_BANNER,
} from "../types";

const initialState = {
  isShowBankDetailBanner: false,
  data: {},
  bankDetails: {},
  teamMember: {},
};

const membershipReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MEMBERSHIP_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case SET_BANK_DETAILS_FOR_MEMBERSHIP:
      return {
        ...state,
        bankDetails: action.payload,
      };
    case SET_MEMBERSHIP_TEAM_MEMBER:
      return {
        ...state,
        teamMember: action.payload,
      };
    case SET_BANK_DETAIL_BANNER:
      return {
        ...state,
        isShowBankDetailBanner: action.payload,
      };
    default:
      return state;
  }
};

export default membershipReducer;

